var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxSubmittedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 166,
    viewBox: "0 0 107 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5254 59.2468L84.3454 16.6268C88.5254 14.2168 93.7454 17.2268 93.7454 22.0568V107.297C93.7454 110.507 92.0354 113.477 89.2454 115.087L15.4254 157.707C11.2454 160.117 6.02539 157.107 6.02539 152.277V67.0368C6.02539 63.8268 7.73539 60.8568 10.5254 59.2468Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98539 153.747V68.5071C8.98539 65.2971 10.6954 62.3271 13.4854 60.7171L87.3054 18.0971C88.7254 17.2771 90.2554 17.1271 91.6654 17.4171C89.7654 15.7071 86.8654 15.1571 84.3454 16.6171L10.5254 59.2371C7.74539 60.8471 6.02539 63.8171 6.02539 67.0271V152.267C6.02539 155.457 8.31539 157.807 11.0654 158.377C9.81539 157.257 8.98539 155.657 8.98539 153.747Z",
    fill: "#E2E8FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7452 62.5669L65.8352 67.8469L38.9552 114.397L22.0952 104.687L27.9252 94.5869L35.7052 99.0069L56.7452 62.5669Z",
    fill: "#CAD6F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7453 67.5669L71.9453 64.7769L77.8153 68.1169L82.6153 70.9069L76.7453 67.5669Z",
    fill: "#C5C5C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7053 104.007L50.9053 101.227L71.9453 64.7769L76.7453 67.5669L55.7053 104.007Z",
    fill: "#1A74EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9255 99.5869L43.1255 96.7969L50.9055 101.227L55.7055 104.007L47.9255 99.5869Z",
    fill: "#C5C5C5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0954 109.687L37.2954 106.897L43.1254 96.7969L47.9254 99.5869L42.0954 109.687Z",
    fill: "#1A74EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7452 67.5669L82.6152 70.9069L55.7452 117.467L42.0952 109.687L47.9252 99.5869L55.7052 104.007L76.7452 67.5669Z",
    fill: "url(#paint0_linear_678_2434)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_678_2434",
    x1: 42.0952,
    y1: 92.521,
    x2: 82.6152,
    y2: 92.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF08B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxSubmittedIcon);
export default __webpack_public_path__ + "static/media/tx-submitted-icon.fe22915c68989578674305bbc57d590d.svg";
export { ForwardRef as ReactComponent };